import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Table from '@components/pages/Flight/DetailsTable'
import GET_FLIGHT from '@graphql/queries/get-flight'

function Details() {
  const { flightId } = useParams()
  const EXCLUDE_FROM_FIELDS = ['__typename', 'transactionId']
  const { data, loading, error } = useQuery(GET_FLIGHT, {
    variables: { id: flightId }
  })

  const fields = data?.flight ? Object.keys(data.flight).filter((key) => !EXCLUDE_FROM_FIELDS.includes(key)) : []

  return (
    <>
      <PageHeading heading='Flight Details' />

      {error ? (
        <Error error={error} />
      ) : (
        <Table
          flight={data?.flight}
          fields={fields}
          loading={loading}
        />
      )}
    </>
  )
}

export default Details
